import React from 'react';
import Styles from './circle-result-styles.scss';
import { parsePercent } from '@/presentation/utils/number-utils';
const CircleResult = ({ percent = 0, correctAnswers = 0, questions = 0 }) => {
    return (React.createElement("div", { className: Styles.circle },
        React.createElement("div", { className: Styles.t1 }, "SCORE"),
        React.createElement("div", { className: Styles.t2 },
            parsePercent(percent),
            "%"),
        React.createElement("div", { className: Styles.t1 },
            correctAnswers,
            " of ",
            questions)));
};
export default CircleResult;
